export { default } from "./KanbanColumnSkeletonView";
export type { KanbanColumnSkeletonViewProps } from "./KanbanColumnSkeletonView";
